var _a;
var CURRENT_LOG_LEVEL = 2; // error level by default
var settings = (_a = {},
    _a[1] = ["fatal", ["#7c002a"], console.error],
    _a[2] = ["info", ["#4454FF", "#7e86de"], console.info],
    _a[3] = ["error", ["#f31"], console.error],
    _a[4] = ["warn", ["#ffcd84"], console.warn],
    _a[5] = ["debug", ["#168d21", "#168d21"], console.log],
    _a[6] = ["trace", ["#aaa"], console.log],
    _a);
var typeToPrintf = function (item) {
    switch (typeof item) {
        case "string":
            return "%s";
        case "boolean":
            return "%o";
        case "number":
            return (0 ^ item) === item ? "%i" : "%f";
        default:
            return "%O";
    }
};
var tryToLog = function (level, scope) {
    if (scope === void 0) { scope = ""; }
    return function (params) {
        if (CURRENT_LOG_LEVEL >= level) {
            if (settings[level]) {
                var _a = settings[level], tag = _a[0], colors = _a[1], log_fn = _a[2];
                log_fn.apply(null, [
                    scope + " %c #%s %c " + params.map(typeToPrintf).join(" "),
                    "background-color:" + (colors[0] || "") + ";color:white;",
                    tag,
                    colors[1] ? "color:" + colors[1] + ";" : ""
                ].concat(params));
            }
        }
    };
};
var scope = function (name) { return ({
    trace: function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return tryToLog(6, name)(params);
    },
    debug: function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return tryToLog(5, name)(params);
    },
    warn: function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return tryToLog(4, name)(params);
    },
    error: function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return tryToLog(3, name)(params);
    },
    info: function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return tryToLog(2, name)(params);
    },
    fatal: function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return tryToLog(1, name)(params);
    }
}); };
var log = Object.assign(scope(), {
    scope: scope,
    setLevel: function (level) { return (CURRENT_LOG_LEVEL = level); }
});

export { log };
//# sourceMappingURL=index.mjs.map
